import { DrawerAndPopover } from "@/shared/components/common/DrawerAndPopover";
import { NestedAction, NestedContentNavigator } from "@/shared/components/ui/NestedContentNavigator";
import { CalendarBlankIcon } from "@phosphor-icons/react";
import { TodoDatePeriod } from "../types";
import { TODO_DATE_PERIOD_FILTERS } from "../constants";

interface TodosDatePeriodFilterProps {
  onFilterChange: (filter: TodoDatePeriod) => void;
}

export function TodosDatePeriodFilter({ onFilterChange }: TodosDatePeriodFilterProps) {
  const filterActions: NestedAction<TodoDatePeriod>[] = Object.values(TODO_DATE_PERIOD_FILTERS).map((filter) => ({
    key: filter.value,
    label: filter.label,
    run: () => onFilterChange(filter.value),
  }));

  return (
    <DrawerAndPopover icon={<CalendarBlankIcon />} id="todo-filter">
      <NestedContentNavigator actions={filterActions} />
    </DrawerAndPopover>
  );
}
